import React, {Fragment} from "react"
import {Modal} from "../common/Modal";
import {CheckBox} from "../common/CheckBox";
import {PhoneUtility} from "../common/PhoneUtility";
import {PillButton} from "../common/PillButton";
import {Constants} from "../common/Constants";
import _ from "lodash";
import {DispatchOrder} from "../../types/DispatchOrder";
import {RadioOptionSet} from "../common/RadioOptionSet";
import {SelectUtility} from "../common/SelectUtility";
import {SelectOption} from "../common/CommonUIElementTypes";

interface DispatchOrderNotificationFormProps {
    statusId: number;
    statusName: string;
    updateDispatchOrderStatus: (statusId: number, disableNavigationBlocker: Function, notification?: any, cancellationReasonId?: number, cancellationText?: string) => void;
    sendDispatchOrderNotification: (disableNavigationBlocker: Function, notification: any) => void;
    formEngine: any;
    close: () => void;
}

export let DispatchOrderNotificationForm = (props: DispatchOrderNotificationFormProps) => {
    let formEngine = props.formEngine;

    function onClickRecipientCheckBox(index: number, checked: boolean) {
        let notificationModalUpdate = _.cloneDeep(formEngine.dataStore.data().notificationModal)
        notificationModalUpdate.foremanData[index].checked = checked
        formEngine.updateAndRenderUnsavedData({notificationModal: notificationModalUpdate})
    }

    function onChangeMessage(text: string) {
        let notificationModalUpdate = _.cloneDeep(formEngine.dataStore.data().notificationModal)
        notificationModalUpdate.message = text
        formEngine.updateAndRenderUnsavedData({notificationModal: notificationModalUpdate})
    }

    function onChangeCancellationText(text: string) {
        let notificationModalUpdate = _.cloneDeep(formEngine.dataStore.data().notificationModal)
        notificationModalUpdate.dispatch_order_cancellation_text = text
        formEngine.updateAndRenderUnsavedData({notificationModal: notificationModalUpdate})
    }

    function handleRadioOptionChange(fieldName: string, option: SelectOption) {
        let notificationModalUpdate = _.cloneDeep(formEngine.dataStore.data().notificationModal)
        notificationModalUpdate[fieldName] = option.value
        formEngine.updateAndRenderUnsavedData({notificationModal: notificationModalUpdate})
    }

    function getNotificationData() {
        return {
            message: formEngine.dataStore.data().notificationModal.message,
            recipient_user_ids: formEngine.dataStore.data().notificationModal.foremanData
                .filter((recipient: any) => recipient.checked)
                .map((recipient: any) => recipient.user_id)
        }
    }

    function changeStatusWithNotification() {
        props.updateDispatchOrderStatus(
            props.statusId,
            formEngine.disableNavigationBlocker,
            getNotificationData(),
            formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_reason_id,
            formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_text
        );
    }

    function changeStatusWithoutNotification() {
        props.updateDispatchOrderStatus(
            props.statusId,
            formEngine.disableNavigationBlocker,
            undefined,
            formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_reason_id,
            formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_text
        );
    }

    function sendNotificationWithoutStatusChange() {
        props.sendDispatchOrderNotification(
            formEngine.disableNavigationBlocker,
            getNotificationData()
        );
    }

    let foremanRows = [];
    for (let i = 0; i < formEngine.dataStore.data().notificationModal.foremanData.length; i++) {
        let foremanDataItem = formEngine.dataStore.data().notificationModal.foremanData[i];
        foremanRows.push(
            <div
                key={i}
                className="notification-recipients-list-row"
            >
                <div className="notification-recipients-list-row-content">
                    <div className="notification-recipients-list-row-cell name">
                        {foremanDataItem.name}
                    </div>
                    <div className="notification-recipients-list-row-cell phone-number">
                        {PhoneUtility.dbPhoneToParenthesesDisplayPhone(foremanDataItem.phone)}
                    </div>
                    <div className="notification-recipients-list-row-cell option">
                        <CheckBox
                            id={i.toString()}
                            checked={foremanDataItem.checked}
                            onChange={(checked: boolean) => onClickRecipientCheckBox(i, checked)}
                        />
                    </div>
                </div>
            </div>
        )
    }

    let optionButtons = [];
    let headerText = "Send activity status update";
    let cancellationDetailsSection: React.ReactNode | null = null;
    let messageSection: React.ReactNode | null = (
        <div className="dispatch-order-notification-message">
            <div className="common-form-field">
                <div className="common-form-field-label">
                    MESSAGE
                </div>
                <div className="common-form-field-input-container">
                    <textarea
                        id="message"
                        className="common-form-input"
                        value={formEngine.dataStore.data().notificationModal.message || ''}
                        onChange={(event) => onChangeMessage(event.target.value)}
                        placeholder="Status update message"
                    />
                </div>
            </div>
        </div>
    );
    let modalClasses = "dispatch-order-notification-modal ";
    let closeIconSrcOverride: string | undefined = undefined;
    if (props.statusName) {
        if (props.statusName === Constants.dispatchOrderStatusNames.cancelled) {
            let cancellationReasonOptions = formEngine.dataStore.data().supportingData.dispatchOrderCancellationReasonOptions;
            headerText = "Cancel activity";
            modalClasses += "cancel-modal";
            messageSection = null;
            closeIconSrcOverride = "/static/images/close-light-gray.svg"

            cancellationDetailsSection = (
                <Fragment>
                    <div className="cancel-reason">
                        <div className="cancel-reason-header">
                            Please select a reason for cancelling this activity.
                        </div>
                        <div className="cancel-reason-options">
                            <RadioOptionSet
                                fieldName="dispatch_order_cancellation_reason_id"
                                wrapperClass="cancel-reason-option-set"
                                options={cancellationReasonOptions}
                                selectedOption={
                                    SelectUtility.selectOptionForId(
                                        formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_reason_id,
                                        cancellationReasonOptions
                                    ) || cancellationReasonOptions[0]
                                }
                                onSelectRadioOption={handleRadioOptionChange}
                            />
                        </div>
                        <div className="dispatch-order-notification-message">
                            <div className="common-form-field">
                                <div className="common-form-field-label">
                                    CANCELLATION DETAILS
                                </div>
                                <div className="common-form-field-input-container">
                                    <textarea
                                        id="dispatch_order_cancellation_text"
                                        className="common-form-input"
                                        value={formEngine.dataStore.data().notificationModal.dispatch_order_cancellation_text || ''}
                                        onChange={(event) => onChangeCancellationText(event.target.value)}
                                        placeholder="Additional cancellation information"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
            optionButtons.push(
                <PillButton
                    key={0}
                    containerClasses="dispatch-order-notification-button-container"
                    buttonClasses="solid-red-button dispatch-order-notification-button"
                    onClick={changeStatusWithNotification}
                    buttonText="CANCEL ACTIVITY"
                />
            )
            optionButtons.push(
                <PillButton
                    key={1}
                    containerClasses="dispatch-order-notification-button-container"
                    buttonClasses="red-border-button dispatch-order-notification-button"
                    onClick={changeStatusWithoutNotification}
                    buttonText="CANCEL ACTIVITY WITHOUT NOTIFICATION"
                />
            )
        } else {
            optionButtons.push(
                <PillButton
                    key={0}
                    containerClasses="dispatch-order-notification-button-container"
                    buttonClasses="solid-black-button dispatch-order-notification-button"
                    onClick={changeStatusWithNotification}
                    buttonText="SEND STATUS UPDATE"
                />
            )
            optionButtons.push(
                <PillButton
                    key={1}
                    containerClasses="dispatch-order-notification-button-container"
                    buttonClasses="black-border-button dispatch-order-notification-button"
                    onClick={changeStatusWithoutNotification}
                    buttonText="SKIP NOTIFICATION"
                />
            )
        }
    } else {
        optionButtons.push(
            <PillButton
                key={0}
                containerClasses="dispatch-order-notification-button-container"
                buttonClasses="solid-black-button dispatch-order-notification-button"
                onClick={sendNotificationWithoutStatusChange}
                buttonText="SEND STATUS UPDATE"
                disabled={!formEngine.dataStore.data().notificationModal.message}
            />
        )
    }

    return (
        <Modal
            boxClass={modalClasses}
            headerText={headerText}
            onClickCloseOption={() => props.close()}
            closeIconSrcOverride={closeIconSrcOverride}
        >
            <div className="dispatch-order-notification-modal-body">
                {cancellationDetailsSection}
                <div className="dispatch-order-notification-recipients-box">
                    <div className="dispatch-order-notification-recipients-box-header">
                        Job Foreman
                    </div>
                    <div className="dispatch-order-notification-recipients-box-body">
                        <div className="notification-recipients-list">
                            <div className="notification-recipients-list-row notification-recipients-list-header">
                                <div className="notification-recipients-list-row-content">
                                    <div className="notification-recipients-list-row-cell name">
                                        Name
                                    </div>
                                    <div className="notification-recipients-list-row-cell phone-number">
                                        Phone number
                                    </div>
                                    <div className="notification-recipients-list-row-cell option"></div>
                                </div>
                            </div>
                            {foremanRows}
                        </div>
                    </div>
                </div>
                {messageSection}
                <div className="dispatch-order-notification-options">
                    <div className="dispatch-order-notification-options-content">
                        {optionButtons}
                    </div>
                </div>
            </div>
        </Modal>
    )
}
